<template>
  <div class="shangquanzizhiPage">
    <div class="xr-mingxi">        
      <mu-appbar class="xr-head" title="商家资质">
        <mu-icon-button icon=":fa fa-angle-left" slot="left" @click="GoHistory()" />
        <mu-icon value=":fa fa-zhuanfa"  slot="right"/>
      </mu-appbar>
    </div>
    <mu-list>
      <mu-list-item title="商家营业执照" class="zhizhao">
          <mu-icon value=":fa fa-fangzi" :size="20" slot="left"/>
      </mu-list-item>
      <mu-list-item class="item-img" v-for="(yyzz,index) in yyzzList" :key="index">
        <img :src="yyzz" alt="">
      </mu-list-item>
    </mu-list>
    <mu-list class="dianpu" style="margin-top:10px;">
      <mu-list-item title="商家店铺照片" class="zhizhao">
          <mu-icon value=":fa fa-fangzi" :size="20" slot="left"/>
      </mu-list-item>
      <mu-list-item class="item-img" v-for="(img,index) in storeImgList" :key="index">
          <img :src="img" alt="">
      </mu-list-item>
    </mu-list>
  </div>
</template>
<script>
import siteconfig from '../../util/siteconfigCache'
export default {
  data() {
    return {
      yyzzList:[],
      storeImgList:[]
    }
  },
  mounted() {
     this.getStorePage()     
  },
  methods: {  
    GoHistory(){
      this.$router.goBack()
    },
    getStorePage(){
      const ths = this;
      this.$post("/Shop/StoreServer/GetShopsPhysicalStoreImages", {'shopId':this.$route.query.shopId})
      .then(function(res) {
        if (res.IsSuccess) {
          ths.loaded = false;
          
          ths.yyzzList = res.Data.YYZZ
          ths.storeImgList = res.Data.ShopImageList

          //ths.$refs.XRtoast.hide();
        }
      })
      .catch(function(err) {
        console.log(err);
      });
    }      
  },
  computed: {
    
  }
};
</script>
<style>
.shangquanzizhiPage .xr-mingxi{
  border-bottom: 1px solid #f5f5f5;
}
.shangquanzizhiPage .xr-mingxi .mu-appbar.fixed{  
  padding:0;
  position: fixed;
  top:0;
  left: 0;
}
.shangquanzizhiPage .xr-mingxi .mu-appbar{
  background-color: #fff;
  color: #000;
}
.xr-mingxi .xr-head .mu-icon{
  color: #aaa;
}
.xr-mingxi .xr-head .fa-xing1{
  font-size: 24px;
  width: 28px;
  margin-right: 5px;
  padding-bottom: 5px;
}
.shangquanzizhiPage .xr-mingxi .mu-appbar-title {
    font-size: 16px;
    text-align: center;
}
.shangquanzizhiPage .xr-mingxi .left .mu-icon-button {
    color:white;
}
.shangquanzizhiPage .xr-mingxi .title .title-text {
    margin: 0;
    line-height: 48px;
}
.shangquanzizhiPage .xr-mingxi .mu-paper-1{
    box-shadow: none;
}
.shangquanzizhiPage .mu-list{
  background: #fff;
  padding-bottom: 0;
}
.shangquanzizhiPage .mu-list .zhizhao{
  border-bottom: 1px solid #f5f5f5;
}
.shangquanzizhiPage .mu-list .mu-item.show-left{
  padding-left: 50px;
}
.shangquanzizhiPage .mu-list .item-img img{
  width: 100%;
}
.shangquanzizhiPage .dianpu .item-img .mu-item{
  padding-bottom: 0;
}
.shangquanzizhiPage .dianpu .item-img:last-child .mu-item{
  padding-bottom: 16px;
}
.shangquanzizhiPage .xr-mingxi .right{
    width: 48px;
    font-size: 16px;
    text-align: center;
}
.shangquanzizhiPage .xr-mingxi .right .fa-zhuanfa{
    width: 48px;
    font-size: 24px;
}
</style>




// WEBPACK FOOTER //
// src/pages/shangquan/zizhi.vue